<template>
  <div>
    <a :href="link" class="stats-box-container flex-row align-items-center" :class="boxClasses" v-if="description">
      <div class="text-left">
        <div class="stat-name">{{ name }}</div>
        <div class="stat-description">{{ description }}</div>
      </div>
      <div class="text-right">
        <div class="stat-unit" :class="unitClasses">{{ unit }}</div>
        <div class="stat-number">{{ number }}</div>
      </div>
    </a>

    <a :href="link" class="stats-box-container" :class="boxClasses" v-else>
      <div class="stat-name">{{ name }}</div>
      <div class="stat-number mt-2 mb-3" :class="unitClasses">{{ number }}</div>
      <div class="stat-unit">{{ unit }}</div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      required: true,
      type: String,
    },
    number: {
      required: true,
    },
    unit: {
      required: true,
      type: String,
    },
    link: {
      required: false,
      type: String,
    },
    description: {
      required: false,
      default: null,
    },
  },

  computed: {
    boxClasses () {
      return {
        static: typeof this.link !== 'string',
      };
    },

    unitClasses () {
      return {
        'font-small': this.name == 'Hours Spent',
      };
    },
  },
};
</script>
